import { Dashboard } from '@mui/icons-material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import React from 'react'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import VehicleCreation from './component/vehicleCreation'
import FilterOrg from '../OrgAmin/components/FilterOrg'
import MDBox from "components/MDBox";

function VehicleCreationReport() {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/* <MDBox mb={4} display="flex" justifyContent="center">
                <FilterOrg />
            </MDBox> */}
            <VehicleCreation />
        </DashboardLayout>
    )
}

export default VehicleCreationReport
